<template>
  <div class="main-page page-notarization-apply">
    <Menu
      title="在线申办"
      :home="true"
    />
    <div class="container-flex">
      <div class="content">
        <div class="title">
          申请须知
        </div>
        <div class="desc">
          <p>微信扫描下方二维码，在手机端进行公证在线申请</p>
          <p>也可通过“云南掌上12348”微信公众号或者“12348云南法网”进行公证业务在线申办</p>
        </div>
        <div class="erweima">
          <img
            width="300"
            src="https://qiniu.laway.cn/yn/2021/06/03/1ee5357ac45411eb9d34b4055d0b07be.jpg"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/components/Menu'
export default {
  components: {
    Menu
  }
}
</script>
<style lang="stylus" scoped>
.content
  width 10rem
  display block
  margin 0.3rem auto 0.3rem auto
  padding 0.5rem 0.65rem 1rem 0.65rem
  background-color rgba(255, 255, 255, 0.2)
  border-radius 0.3rem
  border solid 1px rgba(255, 255, 255, 0.2)
  color #fff
  .title
    font-size 0.3rem
    line-height 0.3rem
    padding-bottom 0.56rem
    letter-spacing 1px
  .desc
    font-size 0.24rem
    line-height 2
  .erweima
    text-align center
    margin-top 0.1rem
</style>